const _ = require('./enum');

const shippingDeliveryMethods = {
  [_.IN_STORE]: {
    id: _.IN_STORE,
    label: 'In store',
  },
  [_.CUSTOMER_ADDRESS]: {
    id: _.CUSTOMER_ADDRESS,
    label: 'Customer address',
  },
  [_.PICKUP]: {
    id: _.PICKUP,
    label: 'Pickup',
  },
  [_.OTHER]: {
    id: _.OTHER,
    label: 'Other',
  },
};

module.exports = shippingDeliveryMethods;
